import { render, staticRenderFns } from "./questionBankPractice.vue?vue&type=template&id=1be78fe8&scoped=true"
import script from "./questionBankPractice.vue?vue&type=script&lang=js"
export * from "./questionBankPractice.vue?vue&type=script&lang=js"
import style0 from "./questionBankPractice.vue?vue&type=style&index=0&id=1be78fe8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be78fe8",
  null
  
)

export default component.exports